export const ACTIONS = {
  SET_IS_AUTHENTICATED: 'SET_IS_AUTHENTICATED',
  SET_PROPERTY: 'SET_PROPERTY'
}
